<template>
  <aside class="card-modal__sidebar">
    <div class="card-modal__sidebar-wrapper">
      <CardModalSidebarLinks />
      <CardModalSidebarActions :card="card" />
    </div>
  </aside>
</template>

<script>
// Components
import CardModalSidebarLinks from './CardModalSidebarLinks'
import CardModalSidebarActions from './CardModalSidebarActions'

export default {
  name: 'CardModalSidebar',

  components: {
    CardModalSidebarLinks,
    CardModalSidebarActions,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.card-modal__sidebar {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: 20px 8px;
  background: var(--c-secondary-400);
  border-bottom-right-radius: 8px;
}

.card-modal__sidebar-wrapper {
  display: grid;
  grid-template-rows: 1fr auto;
  row-gap: 40px;
  height: 100%;
  margin: 0 auto;
}
</style>
